export enum ContactPointTypeEnum {
  UNKNOWN = "unknown",
  SALES = "sales",
  LOGISTICS = "logistics",
  BILLING = "billing",
}
